import { jsx } from "panel";
import { InputEl } from "common/components/input";
import { ItemsMenuEl } from "common/components/items-menu";
import { SvgIconEl } from "common/components/svg-icon";
import { TooltipEl } from "common/components/tooltip";
export function template() {
  const { searchFilter } = this.state;
  return /* @__PURE__ */ jsx("nav", {
    sel: ".mp-panel"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".mp-logo"
  }, /* @__PURE__ */ jsx(SvgIconEl, {
    sel: ".mp-logo-svg",
    attrs: { icon: `mixpanel-logo` }
  }), /* @__PURE__ */ jsx("div", {
    sel: ".mp-logo-title"
  }, "Mixpanel Design")), /* @__PURE__ */ jsx("div", {
    sel: ".nav-search"
  }, /* @__PURE__ */ jsx(InputEl, {
    attrs: { icon: `search`, placeholder: `Search` },
    on: { input: this.helpers.handleSearchInput },
    hook: { insert: ({ elm }) => this.setElRef(`searchInput`, elm) }
  }), /* @__PURE__ */ jsx(TooltipEl, null, "Search Shortcut: Alt+f")), /* @__PURE__ */ jsx(ItemsMenuEl, {
    attrs: {
      "search-filter": searchFilter,
      sections: this.getSections()
    },
    on: { clickItem: this.helpers.handleItemClick },
    props: { keydownProxyEl: this.elRefs.searchInput }
  }));
}
